import 'mlmi-library/components/select/v1/select'

$.fn.modeInspiration = function() {
  let self = this

  self.find('.grid-filters').each(function() {
    var filter = $(this)
    var dropdwon_el = $('<select class="js-ajaxify-select"></select>');
    filter.find('.js-ajaxify-grid-item').each(function(i) {
      var option = $(this);
      option.attr('data-id', i);
      $('<option value="' + i + '">' + option.html() + '</option>').appendTo(dropdwon_el);
    })
    dropdwon_el.prependTo(filter);
    dropdwon_el.on('change', function() {
      self.find('.js-ajaxify-grid-item[data-id=' + $(this).val() + ']').click();
    });
    dropdwon_el.Select();

  })
  //
  // self.find('.grid-filters__btn').click(function() {
  //   if ($(this).attr('data-filter-tax') != '') {
  //     $('.grid-header .grid-filters__btn[data-filter-tax=' + $(this).attr('data-filter-tax') + '][data-id=' + $(this).attr('data-id') + ']').click();
  //   }
  // })

  self.find('.mode-inspiration__filters__submit').click(function() {
    self.changeTestimonials();
    var show_featured = 1;
    self.find('.grid-filters').each(function() {
      var first_button = $(this).find('.grid-filters__btn').eq(0)
      if (first_button.attr('data-filter-tax') != '') {
        $('.grid-header .grid-filters__btn[data-filter-tax=' + first_button.attr('data-filter-tax') + '][data-id=' + $(this).find('.js-ajaxify-select').val() + ']').click();
      }
      if ($(this).find('.js-ajaxify-select').val() != '0') {
        show_featured = 0;
      }
    })

    if (show_featured) {
      $('.hide-when-filtered').each(function() {
        $(this).css('--max-height', '')
      })
      $('.hide-when-filtered').removeClass('--hide');
    } else {
      $('.hide-when-filtered').each(function() {
        $(this).css('--max-height', $(this).innerHeight() + 'px')
      })
      $('.hide-when-filtered').addClass('--hide');
    }
    window.scrollTo(0, 0)
    self.removeClass('--open-filters')
  })

  self.find('.mode-inspiration__filters__title').click(function() {
    if (!self.hasClass('--open-filters')) {
      self.addClass('--open-filters')
      self.removeClass('--close-filters')
    } else if(!self.hasClass('--close-filters')) {
      self.addClass('--close-filters')
      self.removeClass('--open-filters')
    }
  })

  self.heightRuler = function() {
    self.find('.mode-inspiration__filters__height-ruler').css('--max-height', self.find('.mode-inspiration__filters__wrapper').height() + 'px')
  }

  $(window).click(function() {
    $('.mode-inspiration__filters').removeClass('--open-filters')
  });

  $('.mode-inspiration__filters').click(function(event) {
    event.stopPropagation();
  });

  self.changeTestimonials = function() {
    $('.grid--style--random-content').css('max-height', $('.grid--style--random-content').height());
    $('.grid--style--random-content').addClass('--changing-elements');
    var currentElement = $('.grid--custom .grid__item[style="display: block;"]');
    var nextElement = currentElement.next();
    if (nextElement.hasClass('grid__loader')) {
      nextElement = $('.grid--custom .grid__item').first();
    }
    nextElement.attr('style', 'display: block;');

    window.setTimeout(function() {
      currentElement.attr('style', '');
      $('.grid--style--random-content').css('max-height', nextElement.height());
      $('.grid--style--random-content').removeClass('--changing-elements');
    }, 500 );
  }



  return function() {
    $(window).on('resize orientationchange load', self.heightRuler)
    return self
  }()
};
